export default __webpack_public_path__ + "static/media/phone.31167757.png";